import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SKIP_AUTH_HEADER } from './auth.interceptor';
import { toCamelCase, toSnakeCase } from '../utils/case-converter';

/**
 * Interceptor to convert request body keys to snake_case
 * and response body keys to camelCase.
 */
export const caseInterceptor: HttpInterceptorFn = (req, next) => {
  // Skip case conversion for requests that opt out (e.g. S3 presigned uploads),
  // for non-API absolute URLs, and for raw File / Blob / FormData bodies.
  const skip = req.headers.has(SKIP_AUTH_HEADER)
    || !req.url.startsWith(environment.apiUrl)
    || req.body instanceof FormData
    || req.body instanceof Blob
    || req.body instanceof ArrayBuffer;

  let jsonReq = req;

  if (!skip && req.body && typeof req.body === 'object') {
    jsonReq = req.clone({
      body: toSnakeCase(req.body)
    });
  }

  return next(jsonReq).pipe(
    map(event => {
      if (!skip && event instanceof HttpResponse && event.body) {
        // Convert response body to camelCase if it's JSON
        return event.clone({
          body: toCamelCase(event.body)
        });
      }
      return event;
    })
  );
};
